var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.wrap},[_c('base-form',{ref:"form",attrs:{"items":_vm.data,"locked":_vm.locked,"label-width":"5em","submit-text":"确定"},on:{"submit":_vm.onSubmit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }